import { combineReducers } from 'redux'

import modal from './modal/newsModal.reducer'

export default combineReducers({
  modal
})
